import React, { useState } from "react";

function MyComponent() {
  const imageURL = process.env.PUBLIC_URL + "/assets";
  const [imageHeights, setImageHeights] = useState([null, null]);

  // Function to update image height in state
  const handleImageLoad = (index, height) => {
    setImageHeights((prevHeights) => {
      const updatedHeights = [...prevHeights];
      updatedHeights[index] = height;
      return updatedHeights;
    });
  };

  return (
    <div className="flex flex-col mx-20 mb-20 max-md:mb-8 max-md:mx-5">
      <div className="self-center text-4xl font-bold text-justify text-black whitespace-nowrap tracking-[2px] mt-20">
        OUR HEAD
      </div>
      <div className="mt-16 w-full max-md:mt-10 max-md:max-w-full">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:w-full">
            <div className="grow w-full bg-white rounded-lg border-2 border-blue-500 border-solid max-md:mt-6 max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div
                  className="flex justify-center w-full max-md:w-full max-md:object-fill"
                  style={{ height: imageHeights[0] }}
                >
                  {/* Half of the container */}
                  <img
                    loading="lazy"
                    src={`${imageURL}/Director.jpg`}
                    alt="Director"
                    className="w-full h-full rounded-md"
                    onLoad={(e) => handleImageLoad(0, e.target.offsetHeight)} // Handle image load to get its height
                  />
                </div>
                <div className="flex flex-col justify-center w-full px-10 py-4 text-custom-ourHead-xs tracking-wide max-md:px-5 max-md:leading-4">
                  <div className="text-black">
                    Dear Everyone,
                    <br />
                    <br />I hope this message finds you well. I want to
                    express my gratitude for entrusting us with your child’s
                    education. Our dedicated team is committed to fostering a
                    supportive and enriching environment where every student
                    can thrive.
                    <br/>
                    <br />
                    As we embark on this journey together, let’s work hand in
                    hand to ensure a year of learning, discovery, and personal
                    growth !!
                    <br />
                  </div>
                  <div className="self-end mt-7 text-right text-neutral-600">
                    <span className="font-bold">Kamlesh Singodia</span>
                    <br />
                    <span className="font-bold">Director</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col w-6/12 max-md:w-full">
            <div className="grow w-full bg-white rounded-lg border-2 border-blue-500 border-solid max-md:mt-6 max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div
                  className="flex justify-center w-full max-md:w-full max-md:object-fill"
                  style={{ height: imageHeights[1] }}
                >
                  {/* Half of the container */}
                  <img
                    loading="lazy"
                    src={`${imageURL}/principal.jpg`}
                    alt="Principal"
                    className="w-full h-full rounded-md"
                    onLoad={(e) => handleImageLoad(1, e.target.offsetHeight)} // Update index to 1 for the second image
                  />
                </div>
                <div className="flex flex-col justify-center w-full px-10 py-4 text-custom-ourHead-xs tracking-wide max-md:px-5 max-md:leading-4">
                  <div className="text-black">
                    Dear Everyone,
                    <br />
                    <br/>
                    With great enthusiasm, I extend a warm welcome to
                    Motherland Children Academy. It is our collective goal to
                    foster a community characterized by learning, respect, and
                    innovation. Together, we can create an environment where
                    every
                    <br/>
                    <br />
                    As we embark on this journey together, let us embrace the
                    opportunities for growth and development that lie ahead !!
                    <br />
                  </div>
                  <div className="self-end mt-7 text-right text-neutral-600">
                    <span className="font-bold">Dheeraj joshi</span>
            <br />
                    <span className="font-bold">Principal</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>  
    </div>
  );
}

export default MyComponent;
